import React from 'react';
import PropTypes from 'prop-types';
import { Wrapper } from './components';

export const BreakpointDisplay = ({ breakpoint, children, under }) => {
  let shouldShow = window.innerWidth > breakpoint;

  if (under) shouldShow = !shouldShow;

  return <Wrapper shouldShow={shouldShow}>{children}</Wrapper>
};

BreakpointDisplay.propTypes = {
  breakpoint: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  under: PropTypes.bool,
};